import React from 'react';
import { IProps as IBlockProps, IPullQuoteItem } from './PullQuoteBlock.interface';
import { PullQuoteBlock } from './PullQuoteBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

// Interface for props expected from an external source (e.g., CMS)
export interface IBlockInputProps {
    items: Array<{
        image?: any
        quote?: string
        name?: string
        qualification?: string

    }>;
    background: ThemeColors;
    [key: string]: any; // Allow passthrough of other props
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { items, background, ...blockWrapperProps } = input;

    const mappedItems: IPullQuoteItem[] = items.map(item => ({
        quote: item.quote || undefined,
        author: item.name || undefined,
        job: item.qualification || undefined,
        image: item.image ? translation.mapImageProps(item.image) : undefined,
    }));

    return {
        items: mappedItems,
        backgroundColor: background || 'white', // Default or fallback value
        ...blockWrapperProps, // Pass through BlockWrapper related settings
    } as IBlockProps; // Type assertion might be needed if icon logic is complex
};

const PullQuoteBlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={PullQuoteBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default PullQuoteBlockTranslation;
